<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="getDialogWidth()">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-NON-USER-TEAM' : 'EDIT-NON-USER-TEAM') | translate }}</h3>
  </kendo-dialog-titlebar>
  <div class="scroll">
    <form novalidate [formGroup]="editForm">
      <kendo-tabstrip #tabstrip>
        <kendo-tabstrip-tab title="{{ 'FORM-EDIT-TAB-GENERAL' | translate }}" [selected]="true">
          <ng-template kendoTabContent>
            <div class="k-form">
              <div class="row">
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'FIRST-NAME' | translate}}
                    </span>
                    <input id="firstName" kendoTextBox formControlName="firstName" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'LAST-NAME' | translate}}
                    </span>
                    <input id="lastName" kendoTextBox formControlName="lastName" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'MIDDLE-NAME' | translate}}
                    </span>
                    <input id="middleName" kendoTextBox formControlName="middleName" maxlength="150" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'GENDER' | translate}}
                    </span>
                    <kendo-combobox class="w-100" id="gender" formControlName="gender" [data]="genders"
                      [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'TITLE-RELATIONSHIP' | translate}}
                    </span>
                    <input id="title" kendoTextBox formControlName="title" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'SUFFIX' | translate}}
                    </span>
                    <input id="suffix" kendoTextBox formControlName="suffix" maxlength="50" />
                  </label>
                </div>
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'PROFESSIONAL-SUFFIX' | translate}}
                    </span>
                    <input id="professionalSuffix" kendoTextBox formControlName="professionalSuffix" maxlength="50" />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'NOTIFICATION' | translate}} *
                    </span>
                    <kendo-combobox class="w-100" formControlName="notification" [data]="notifications"
                      [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.value | translate }}">
                        </span>
                      </ng-template>
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="notification.hasError('required') && notification.touched">
                      {{'REQUIRED-NOTIFICATION' | translate}}
                    </div>
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'TAX-NO' | translate}}
                    </span>
                    <input id="taxNo" kendoTextBox formControlName="taxNo" />
                  </label>
                </div>
                <div class="col-6">
                  <label class="k-form-field" title="{{npi.value}}">
                    <span class="k-text-uppercase dark">
                      {{'PROVIDER-NPI' | translate}}
                    </span>
                    <input id="npi" kendoTextBox formControlName="npi" class="w-100" maxlength="50" />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ROLE' | translate}} *
                    </span>
                    <kendo-combobox id="role" formControlName="role" class="w-100" [valuePrimitive]="false"
                      [data]="teamRolesFiltered" [textField]="'name'" [valueField]="'id'" [filterable]="true"
                      (filterChange)="filterTeamRoles($event)" (close)="searchTerm=''" [itemDisabled]="itemDisabled"
                      [virtual]="virtualSubRole" (valueChange)="getSubRole($event?.teamType?.id)">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                        </span>
                      </ng-template>
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls['role'].invalid && editForm.controls['role'].touched">
                      {{'REQUIRED-ROLE' | translate}}
                    </div>
                  </label>
                </div>
                <div class="col-6">
                  <label class="k-form-field" *ngIf="displaySubRoles">
                    <span class="k-text-uppercase dark">
                      {{'SUBROLE' | translate}} *
                    </span>
                    <kendo-combobox id="subRole" class="w-100" formControlName="subRole" [data]="subRoles"
                      [textField]="'displayName'" [valueField]="'id'">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls['subRole'].invalid && editForm.controls['subRole'].touched">
                      {{'REQUIRED-SUBROLE' | translate}}
                    </div>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ORGANIZATION' | translate}}
                    </span>
                    <input id="organization" kendoTextBox formControlName="organization" />
                  </label>
                </div>
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}" class="fas fa-link fa-fw"></i>
                      {{'URL' | translate}}&nbsp;
                    </span>
                    <input id="url" kendoTextBox formControlName="url" class="w-100" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                      {{'INVALID-WWW' | translate}}
                    </div>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'PROVIDER-DESCRIPTION' | translate}}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100" formControlName="description"
                      maxlength="255"></textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="description.hasError('required') && description.touched">
                      {{'REQUIRED-PROVIDER-DESCRIPTION' | translate}}
                    </div>
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ACTIVE-FROM' | translate}}
                    </span>
                    <kendo-datepicker formControlName="from">
                    </kendo-datepicker>
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ACTIVE-TO' | translate}}
                    </span>
                    <kendo-datepicker formControlName="to">
                    </kendo-datepicker>
                  </label>
                </div>
              </div>
              <div *ngIf="accountCreated.value || accountActivated">
                <span *ngIf="accountActivated"><i class="fas fa-exclamation-triangle icon-warn"></i>
                  <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                    {{'ACCOUNT-CREATED-AND-ACTIVATED' | translate}}
                  </span>
                </span>
                <span *ngIf="createAccount.value && !accountActivated"><i
                    class="fas fa-exclamation-triangle icon-warn"></i>
                  <span class="k-text-uppercase icon-warn text-center warn-modal-text">
                    {{'ACCOUNT-CREATED-AND-BUT-NOT-ACTIVATED' | translate}}
                  </span>
                </span>
              </div>
            </div>
            <div>* {{'REQUIRED-FIELDS' | translate}}</div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'ADDRESS' | translate }}">
          <ng-template kendoTabContent>
            <div class="k-form">
              <div class="row">
                <div class="col-8">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'STREET' | translate}}
                    </span>
                    <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100" /> <i
                      *ngIf="!controlsDisabled && addressAPIEnabled && streetLine.value"
                      class="far fa-search-location pointer ml-3 fa-1_5x"
                      style="color:#3e807c;position:absolute;top:43px;" title="{{'VALIDATE-ADDRESS-ICON' | translate}}"
                      (click)="validateAddress()"></i>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-8">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ADDRESS-LINE-2' | translate}}
                    </span>
                    <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional"
                      class="w-100" />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'CITY' | translate}}
                    </span>
                    <input id="city" kendoTextBox formControlName="city" class="w-100" />
                  </label>
                </div>
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'COUNTY' | translate}}
                    </span>
                    <input id="county" kendoTextBox formControlName="county" class="w-100" />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'STATE' | translate}}
                    </span>
                    <kendo-combobox id="state" class="w-100" formControlName="state" [data]="states"
                      [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'POSTAL-CODE' | translate}}
                    </span>
                    <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" />
                  </label>
                </div>
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'COUNTRY' | translate}}
                    </span>
                    <kendo-combobox id="country" class="w-100" formControlName="country" [data]="countries"
                      [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'CONTACT' | translate }}">
          <ng-template kendoTabContent>
            <div class="k-form">
              <div class="row">
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-phone fa-fw"></i> {{'HOME-OR-PRACTICE-PHONE' | translate}}
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="homePhoneNumber" formControlName="homePhoneNumber"
                      class="w-100">
                    </kendo-maskedtextbox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls['homePhoneNumber'].invalid && editForm.controls['homePhoneNumber'].touched">
                      {{'REQUIRED-PHONE' | translate}}
                    </div>
                  </label>
                </div>
                <div class="col-2 pl-0">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'PHONE-EXTENSION' | translate}}
                    </span>
                    <input id="homePhoneNumberExtension" kendoTextBox formControlName="homePhoneNumberExtension"
                      class="w-100" maxlength="20" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhoneNumber" formControlName="cellPhoneNumber"
                      class="w-100">
                    </kendo-maskedtextbox>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-phone-office fa-fw"></i> {{'WORK-PHONE' | translate}}
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="workPhoneNumber" formControlName="workPhoneNumber"
                      class="w-100">
                    </kendo-maskedtextbox>
                  </label>
                </div>
                <div class="col-2 pl-0">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'PHONE-EXTENSION' | translate}}
                    </span>
                    <input id="workPhoneNumberExtension" kendoTextBox formControlName="workPhoneNumberExtension"
                      class="w-100" maxlength="20" />
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-phone fa-fw"></i> {{'OTHER-PHONE' | translate}}
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="otherPhoneNumber"
                      formControlName="otherPhoneNumber" class="w-100">
                    </kendo-maskedtextbox>
                  </label>
                </div>
                <div class="col-3">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-fax fa-fw"></i> {{'FAX-OR-OTHER' | translate}}
                    </span>
                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber" formControlName="faxNumber"
                      class="w-100">
                    </kendo-maskedtextbox>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-at fa-fw"></i> {{'DIRECT-ADDRESS' | translate}}
                    </span>
                    <input id="directAddress" kendoTextBox formControlName="directAddress" email maxlength="512" />
                  </label>
                </div>
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}&nbsp;<span
                        *ngIf="emailRequired">*</span>
                    </span>
                    <input id="email" kendoTextBox formControlName="email" email />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls['email'].invalid && editForm.controls['email'].touched && !email.hasError('required')">
                      {{'WRONG-EMAIL-FORMAT' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="email.hasError('required') && email.touched">
                      {{'REQUIRED-EMAIL' | translate}}
                    </div>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label for="spokenLanguages" class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'SPOKEN-LANGUAGES' | translate}}
                    </span>
                    <kendo-multiselect id="spokenLanguages" [data]="spokenLanguagesFiltered"
                      formControlName="spokenLanguages" [textField]="'displayName'" [filterable]="true"
                      [valueField]="'id'" (filterChange)="filterSpokenLanguages($event)" (close)="searchTerm=''"
                      [autoClose]="true" [virtual]="virtualSpokenLanguage">
                      <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
                        </span>
                      </ng-template>
                    </kendo-multiselect>
                  </label>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-4 pl-0 mt-3">
                  <input id="createAccount" type="checkbox" class="ml-3" formControlName="createAccount"
                    kendoCheckBox />
                  <label class="k-checkbox-label" for="createAccount" style="display: initial;">{{ 'SEND-REGISTRATION' |
                    translate }}
                  </label>
                </div>
                <div class="col-4 pl-0" *ngIf="createAccount && createAccount.value">
                  <label for="accountRole" class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'USER-ROLE' | translate}} *
                    </span>
                    <kendo-combobox class="w-100" formControlName="accountRole" [data]="roles" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="accountRole.hasError('required') && accountRole.touched">
                      {{'REQUIRED-USER-ROLE' | translate}}
                    </div>
                  </label>
                </div>
                <div class="col-4" *ngIf="createAccount && createAccount.value">
                  <label for="accountOrganization" class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'ORGANIZATION' | translate}} *
                    </span>
                    <kendo-combobox id="accountOrganization" class="w-100" [data]="organizationsFiltered"
                      [valueField]="'id'" [textField]="'name'" formControlName="accountOrganization" [filterable]="true"
                      [readonly]="isCommunityCoordinatorRole" (filterChange)="filterOrganizations($event)"
                      [itemDisabled]="itemDisabled" [valuePrimitive]="false">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="accountOrganization.hasError('required') && accountOrganization.touched">
                      {{'REQUIRED-ORGANIZATION' | translate}}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'IDENTIFIERS' | translate }}" *ngIf="identifiersVisible">
          <ng-template kendoTabContent>
            <div class="tab-identifiers">
              <div class="p-1">
                <button kendoButton [primary]="true" (click)="addIdentifier()" type="button" class="mb-2">
                  {{'ADD-IDENTIFIER' | translate}}<i class="far fa-plus"></i>
                </button>
                <div formArrayName="identifiers" class="container-opening-times">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>
                          <label class="k-text-uppercase dark font-weight-normal">{{ 'TYPE' | translate }} *</label>
                        </th>
                        <th>
                          <label class="k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }} * </label>
                        </th>
                        <th>
                          <label class="k-text-uppercase dark font-weight-normal">{{ 'SOURCE' | translate }} </label>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let option of editForm.controls.identifiers.controls; let i=index"
                        [formGroupName]="i">
                        <td style="width:35%">
                          <kendo-combobox formControlName="type" [data]="types" [textField]="'displayName'"
                            [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                          </kendo-combobox>
                          <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.identifiers.controls[i].controls.type.hasError('required') && 
                                                                             editForm.controls.identifiers.controls[i].controls.type.touched">
                            {{ 'REQUIRED-TYPE' | translate }}
                          </div>
                        </td>
                        <td style="width:25%">
                          <input id="value" kendoTextBox formControlName="value" class="w-100" />
                          <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.identifiers.controls[i].controls.value.hasError('required') &&
                                                                             editForm.controls.identifiers.controls[i].controls.value.touched">
                            {{ 'REQUIRED-VALUE' | translate }}
                          </div>
                        </td>
                        <td style="width:30%">
                          <kendo-combobox formControlName="source" [data]="sources" [textField]="'displayName'"
                            [valueField]="'id'" [valuePrimitive]="false" class="w-100">
                          </kendo-combobox>
                        </td>
                        <td>
                          <a title="{{ 'DELETE' | translate }}"
                            (click)="removeIdentifier(i,editForm.controls.identifiers.controls[i].controls.id.value)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div>* {{'REQUIRED-FIELDS' | translate}}</div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'EXTENSIONS' | translate }}"
          *ngIf="identifiersVisible && (viewExtensions?.gridData?.total > 0 || ctExtensionsEditable)">
          <ng-template kendoTabContent>
            <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
              [navigable]="true" [sort]="viewExtensions.state.sort" [resizable]="true" style="max-height: 400px;"
              (dataStateChange)="dataStateChange($event)" [kendoGridSelectBy]="'id'"
              (add)="ctExtensionAddHandler($event)" (save)="ctExtensionSaveHandler($event)"
              (edit)="ctExtensionEditHandler($event)" (cancel)="ctExtensionCancelHandler($event)">
              <kendo-grid-messages noRecords="{{ 'NO-CARE-TEAM-EXTENSIONS' | translate }}">
              </kendo-grid-messages>
              <!--Organization Name -->
              <kendo-grid-column field="settingExtension.organization.name"
                title="{{ 'SOURCE-ORGANIZATION' | translate }}" [width]="50" [filterable]="false" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    *ngIf="dataItem.settingExtension.organization">{{dataItem.settingExtension.organization.name}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="ctExtensionFormGroup">
                    <kendo-combobox id="organization" formControlName="organization" [data]="organizations"
                      [textField]="'name'" [valueField]="'id'" (valueChange)="organizationChange(true)"
                      [readonly]="!isOperatorRole">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span
                          [ngClass]="{'font-weight-bold': isOrganizationHasExtension(dataItem.id)}">{{dataItem.name}}</span>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Extension Name-->
              <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
                [filterable]="false" [sortable]="true">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="ctExtensionFormGroup">
                  <kendo-dropdownlist [data]="extensionsByCategoryAndOrganizationUnused" textField="name"
                    valueField="id" [valuePrimitive]="false"
                    [formControl]="ctExtensionFormGroup.get('settingExtension')">
                  </kendo-dropdownlist>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="ctExtensionFormGroup">
                    <input kendoTextBox formControlName="value" maxlength="10485760" />
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="ctExtensionsEditable">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <ng-container *ngIf="dataItem.editing">
                    <ng-container *ngIf="ctExtensionFormGroup !== null && ctExtensionFormGroup.valid">
                      <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="ctExtensionSaveButton.click.emit($event); dataItem.editing = false">
                      </i>
                      &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                      (click)="ctExtensionCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #ctExtensionSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #ctExtensionCancelButton class="d-none"></button>
                  </ng-container>
                  <ng-container *ngIf="!dataItem.editing">
                    <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                      (click)="ctExtensionEditButton.click.emit($event); dataItem.editing = true;"></i>
                    &nbsp;
                    <button kendoGridEditCommand #ctExtensionEditButton class="d-none"></button>
                    <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                      (click)="deleteCareTeamExtension(dataItem)"></i>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
              <button kendoGridAddCommand #ctExtensionAddButton class="d-none"></button>
            </kendo-grid>
            <button kendoButton *ngIf="ctExtensionsEditable" type="button" class="float-right mt-3 mb-3"
              (click)="ctExtensionAddButton.click.emit($event)">
              {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </form>
  </div>
  <kendo-dialog-actions>
    <button *ngIf="!isNew" class="k-button k-primary" [disabled]="isNew" (click)="confirmDeleteDialogOpened = true"
      style="position:absolute;left:15px">{{ 'DELETE' | translate }}
    </button>
    <button *ngIf="(providerEnabled || kno2Enabled) && accessProviders" kendoButton [primary]="false"
      title="{{ 'FIND-PROVIDER' | translate }}" class="mr-2" (click)="searchProviders()" type="button">
      {{ 'FIND-PROVIDER' | translate }}<i class="fal fa-search-location"></i>
    </button>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty || saving"
      (click)="onSave($event)">{{
      'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<!-- confirm erase dialog -->
<kendo-dialog *ngIf="confirmDeleteDialogOpened" (close)="confirmDeleteDialogOpened = false" [minWidth]="400">
  <kendo-dialog-titlebar>
    <h3>{{'DELETE-TEAM-MEMBER' | translate}}</h3>
  </kendo-dialog-titlebar>
  <label>{{'CONFIRM-DELETE-TEAM-MEMBER' | translate:patientLabel}}</label>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="confirmDeleteDialogOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="onDelete($event); confirmDeleteDialogOpened = false">
      {{'YES' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Search directory-->
<app-directory-search #directorySearch [allowSelection]="true" [singleSelectionOnly]="true" [allowFacilitySearch]="true"
  [doNotResetScrollOnClose]="true" [showOrganizationsTab]="false" [disableEscape]="true" [memberId]="memberId"
  (selectProvider)="onSelectProviders($event)">
</app-directory-search>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="saveCareTeam()"
  (cancelling)="saving = false;">
</app-address-validator>